import {API} from "../api/api";
import clientFactory from "../factories/http_client";

class ProjectAttachmentService {

	/** @return  Promise<AxiosResponse<T>> */
	get = (projectId, attachmentId) => {
		return clientFactory.client(API.data.scope)
		                    .request({
			                             method: API.data.projects.id.attachments.id.method,
			                             url: API.data.projects.id.attachments.id.url(projectId, attachmentId)
		                             });
	};

	/** @return  Promise<AxiosResponse<T>> */
	create = (projectId, attachment) => {
		return clientFactory.client(API.data.scope)
		                    .request({
			                             method: API.data.projects.id.attachments.create.method,
			                             url: API.data.projects.id.attachments.create.url(projectId),
			                             data: API.data.projects.id.attachments.create.build(attachment),
			                             headers: {
				                             'Content-Type': 'application/json',
			                             }
		                             });
	};

	/** @return  Promise<AxiosResponse<T>> */
	save = (projectId, attachment) => {
		return clientFactory.client(API.data.scope)
		                    .request({
			                             method: API.data.projects.id.attachments.save.method,
			                             url: API.data.projects.id.attachments.save.url(projectId),
			                             data: API.data.projects.id.attachments.save.build(attachment),
			                             headers: {
				                             'Content-Type': 'application/json',
			                             }
		                             });
	};

	/** @return  Promise<AxiosResponse<T>> */
	delete = (projectId, attachmentId) => {
		return clientFactory.client(API.data.scope)
		                    .request({
			                             method: API.data.projects.id.attachments.delete.method,
			                             url: API.data.projects.id.attachments.delete.url(projectId),
			                             data: API.data.projects.id.attachments.delete.build(attachmentId),
			                             headers: {
				                             'Content-Type': 'application/json',
			                             }
		                             });
	};
}

export default ProjectAttachmentService